module.exports = __webpack_public_path__ + "static/media/Caminos_logo.a3488171.png";